import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import '../styles/Referral.css';

const FRONTEND_URL = process.env.REACT_APP_FRONTEND_URL || window.location.origin;

function Referral() {
  const { user } = useAuth();
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    // Reset copied state after 3 seconds
    if (copied) {
      const timer = setTimeout(() => setCopied(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [copied]);

  if (!user || !user.referral_code) {
    return (
      <div className="referral-container">
        <div className="referral-error">
          <p>Referral code not available. Please verify your email first.</p>
        </div>
      </div>
    );
  }

  // Build referral link with user's address information
  const referralLink = `${FRONTEND_URL}/?ref=${user.referral_code}&city=${encodeURIComponent(user.city || '')}&country=${encodeURIComponent(user.country || '')}&address=${encodeURIComponent(user.full_address || '')}`;

  const handleCopyLink = () => {
    navigator.clipboard.writeText(referralLink).then(() => {
      setCopied(true);
    }).catch((err) => {
      console.error('Failed to copy link:', err);
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = referralLink;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand('copy');
        setCopied(true);
      } catch (fallbackErr) {
        console.error('Fallback copy failed:', fallbackErr);
      }
      document.body.removeChild(textArea);
    });
  };

  return (
    <div className="referral-container">
      <div className="referral-content">
        <h2 className="referral-title">Referral Program</h2>
        <p className="referral-description">
          Share your referral link with friends and family. When they register using your link,
          they'll automatically have your city, country, and address pre-filled in the registration form.
        </p>

        <div className="referral-code-section">
          <label className="referral-label">Your Referral Code:</label>
          <div className="referral-code-display">
            <span className="referral-code">{user.referral_code}</span>
          </div>
        </div>

        <div className="referral-link-section">
          <label className="referral-label">Your Referral Link:</label>
          <div className="referral-link-container">
            <input
              type="text"
              value={referralLink}
              readOnly
              className="referral-link-input"
            />
            <button
              className="copy-button"
              onClick={handleCopyLink}
            >
              {copied ? '✓ Copied!' : 'Copy Link'}
            </button>
          </div>
        </div>

        <div className="referral-info">
          <h3>How it works:</h3>
          <ul>
            <li>Share your referral link with others</li>
            <li>When they click the link, they'll be taken to the registration page</li>
            <li>The registration form will be pre-filled with your city, country, and address</li>
            <li>They can edit these fields if needed before submitting</li>
          </ul>
        </div>

        <div className="referral-address-preview">
          <h3>Address that will be pre-filled:</h3>
          <div className="address-details">
            <p><strong>City:</strong> {user.city || 'Not set'}</p>
            <p><strong>Country:</strong> {user.country || 'Not set'}</p>
            <p><strong>Full Address:</strong> {user.full_address || 'Not set'}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Referral;
